import React, {FC} from 'react';
import "./CustomSpinnerComp.scss";
import ScaleLoader  from  "react-spinners/ScaleLoader";

const CustomSpinnerComp  : FC = () => {
    /* Pure component */
  return (
    <>
        <div className="__spinner">
        <ScaleLoader color={"#5262BC"} />
        </div>    
    </>
  )
}

export default React.memo(CustomSpinnerComp);